import styled, { css } from 'styled-components';

import { asterisk } from '@ch/common/utils';
import { LabelProps } from './types';
import { colors } from '@ch/common/const/color';
import { spacingStyle } from '@ch/common/const/spacing';
import { font } from '@ch/common/const/font';
import { FormDefault } from '@ch/common/const/form-element';

const overlapLabelStyles = () => css`
  background-color: ${colors.white};
  color: ${colors.black};
  font-size: 10px;
  font-weight: ${font.weight.light};
  padding: 0 5px;
  line-height: 1;
  left: 17px;
  position: absolute;
  top: -0.6em;
  z-index: 1;
`;

export const FormLabelStyled = styled('label')<LabelProps>`
  color: ${FormDefault.controlLabelColor};
  display: block;
  font-size: ${({ measure }) => font.size[measure]}px;
  line-height: ${({ measure }) => font.lineHeight[measure]}px;
  font-weight: 500;
  margin-bottom: 4px;
  ${({ required }) => required && asterisk()};
  ${props => spacingStyle(props)};
  ${({ type }) => type === 'overlap' && overlapLabelStyles()};
  ${({ isError }) =>
    isError &&
    `
      color: ${colors.warning};
    `}
`;
